// extracted by mini-css-extract-plugin
export var container = "Card-module--container--+g4zS";
export var isEven = "Card-module--isEven--9xrkM";
export var link = "Card-module--link--IFh-S";